
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">Software Solutions</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['/projects']">Projects</a></li>
        <li class="breadcrumb-item"><a [routerLink]="['/project']" [queryParams]="{id: projectId}">{{ this.projectDetails.name }}</a></li>
        <li class="breadcrumb-item active">Software Solutions</li>
      </ol>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="alert alert-warning" *ngIf="softwareSolutions.form.dirty"><span>You have unsaved changes.</span>
        <button class="btn btn-sm btn-primary float-right" type="button" (click)="saveChanges()">Confirm Changes</button>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
  <md-spinner-block *ngIf="loading"></md-spinner-block>
  <div class="row" *ngIf="!loading" [formGroup]="softwareSolutions.form">
    <div class="col table-card">
      <list-controls [search]="searchText" [searchHelp]="searchHelp" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"><a class="btn btn-primary" href="javascript:void(0)" (click)="addSoftwareSolutionItem()">Add Software</a></list-controls>
      <table class="table table-responsive table-striped table-sm" formArrayName="items">
        <thead>
          <tr class="table-header-with-controls">
            <th>Device Key</th>
            <th>Description</th>
            <th>Product type</th>
            <th>Quantity Purchased</th>
            <th>Quantity Deployed</th>
            <th>Install Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let solution of softwareSolutions.filtered" [formGroupName]="solution.index">
            <ng-template [ngIf]="!solution.editing" [ngIfElse]="softwareSolutionItemEdit">
              <td>{{ solution.dsId }}</td>
              <td>{{ solution.solutionsPn }}</td>
              <td>{{ solution.prdSold }}</td>
              <td>{{ solution.qtyPurchased }}</td>
              <td>{{ solution.qtyDeployed }}</td>
              <td>{{ solution.installDate | date }}</td>
              <td>
                <list-edit-controls [item]="solution" [list]="softwareSolutions"></list-edit-controls>
              </td>
            </ng-template>
            <ng-template #softwareSolutionItemEdit>
              <td colspan="7">
                <div class="row justify-content-md-center">
                  <div class="col-md-10">
                    <div class="row">
                      <div class="form-group col-12">
                        <label class="required" for="softwareDeviceList">Software Device</label>
                        <input class="form-control form-control-sm" id="softwareDeviceList" type="text" [ngbTypeahead]="search" [resultFormatter]="formatter" (selectItem)="selectedItem($event, solution.index)" [value]="solution.solutionsPn">
                      </div>
                      <div class="form-group col-md-6">
                        <label class="required" for="installDate">Install Date</label>
                        <div class="input-group">
                          <input class="form-control form-control-sm" id="installDate" type="text" name="installDate" formControlName="installDate" [value]="solution.installDate">
                          <datepicker class="right input-group-append" formControlName="installDate" [value]="solution.installDate"></datepicker>
                        </div>
                      </div>
                      <div class="form-group col-md-6">
                        <label for="solutionStartDate">Solution Install Date</label>
                        <div class="input-group">
                          <input class="form-control form-control-sm" id="solutionStartDate" type="text" name="solutionsInstallDate" formControlName="solutionsInstallDate" [value]="solution.solutionsInstallDate">
                          <datepicker class="right input-group-append" formControlName="solutionsInstallDate" [value]="solution.solutionsInstallDate"></datepicker>
                        </div>
                      </div>
                      <div class="form-group col-md-6">
                        <label class="required" for="productSold">Product Sold</label>
                        <select class="form-control form-control-sm" id="productSold" required formControlName="prdSold">
                          <option value="">Select an option...</option>
                          <option value="Server">Server</option>
                          <option value="Device">Device</option>
                        </select>
                      </div>
                      <div class="form-group col-md-6">
                        <label class="required" for="qtyDeployed">Quantity Deployed</label>
                        <input class="form-control form-control-sm" id="qtyDeployed" type="number" name="qtyDeployed" formControlName="qtyDeployed" min="0">
                      </div>
                      <div class="form-group col-md-6">
                        <label for="changeOrderId">Change Order ID</label>
                        <input class="form-control form-control-sm" id="changeOrderId" type="text" formControlName="coId">
                      </div>
                      <div class="form-group col-md-6">
                        <label for="licenseNr">License Number</label>
                        <input class="form-control form-control-sm" id="licenseNr" type="text" formControlName="licenseNr">
                      </div>
                      <div class="form-group col-md-6">
                        <label for="custom1">Custom 1</label>
                        <input class="form-control form-control-sm" id="custom1" type="text" formControlName="custom1">
                      </div>
                      <div class="form-group col-md-6">
                        <label for="custom2">Custom 2</label>
                        <input class="form-control form-control-sm" id="custom2" type="text" formControlName="custom2">
                      </div>
                      <div class="col-lg-12">
                        <list-edit-controls class="float-right" [item]="solution" [list]="softwareSolutions"></list-edit-controls>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </ng-template>
          </tr>
          <tr *ngIf="softwareSolutions.filteredLength === 0">
            <td colspan="8">
              <p class="text-center empty-table-message">There are no software solutions to display.</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>